var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M12.794 6.114c.694 2.508 2.636 4.488 5.129 5.19m-3.64-6.913L4.185 14.392c-.328.332-.64.979-.705 1.444l-.46 3.285c-.163 1.194.657 2.024 1.837 1.858l3.247-.465c.459-.066 1.098-.381 1.426-.713L19.628 9.799c1.46-1.476 2.165-3.202 0-5.392-2.164-2.206-3.87-1.51-5.345-.016Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ed4a13aa881b87650c9b60314199a15e.svg";
export { ForwardRef as ReactComponent };